import { BookingWidget } from './booking-widget';
import { BookingWidgetFields } from "./booking-widget.fields";
import type { BookingWidgetProps } from './booking-widget';
import type { ComponentConfig } from '@puckeditor/core';
import type { JobsiteBusinessContext } from '../../types/runtime-config';
import { getWindowJobsiteConfig } from '../../types/runtime-config';

const BookingWidgetConfig: ComponentConfig<BookingWidgetProps> = {
  defaultProps: {
    heading: "Book your service",
    subheading: "Pick a time that works — verify by text, no account needed.",
  },
  fields: {
    heading: { ...BookingWidgetFields.heading, contentEditable: true },
    subheading: { ...BookingWidgetFields.subheading, contentEditable: true },
    backgroundColor: BookingWidgetFields.backgroundColor,
  },
  label: "Booking Widget",
  render: ({ id, puck, ...props }) => {
    // Business slug + apiUrl flow from the injected metadata (Puck editor) or
    // The window runtime config (live jobsite). The booking API resolves on slug.
    const puckMetadata = puck?.metadata as { business?: JobsiteBusinessContext } | undefined,
      windowConfig = getWindowJobsiteConfig(),
      business = puckMetadata?.business || windowConfig?.business;

    return (
      <BookingWidget
        id={id}
        {...props}
        slug={business?.slug}
        apiUrl={windowConfig?.apiUrl}
        businessName={business?.name}
        businessPhone={business?.phone || business?.telephone}
      />
    );
  },
};

export { BookingWidgetConfig };
